import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import hiphen from '../../../../assets/images/hiphen.svg'
import { ResponsiveSVG } from 'ui/acro'

import {
  addCustomDurationFilter,
  applyDurationFilter
} from 'redux/actions/planEntries'

const OuterContainer = styled.div`
  display: flex;
  width: 90%;
  gap: 5px;
  padding-left: 5px;
  align-items: center;
  @media screen and (min-width: 1410px) {
    gap: 10px;
  }
`

const InputBox = styled.input`
  width: 45px;
  padding: 6px 8px;

  @media (max-width: 1024px) {
    width: 64px;
    padding: 12px 16px;
  }

  @media screen and (min-width: 1100px) {
    width: 50px;
    padding: 8px 10px;
  }
  @media screen and (min-width: 1410px) {
    width: 64px;
    padding: 12px 16px;
  }

  border: 1px solid #a3a3a3;
  font-family: 'Proxima-Nova';
  letter-spacing: 0.352px;
`

const Apply = styled.a`
  color: #000;
  font-family: 'Proxima-Nova';
  letter-spacing: 0.352px;
  text-decoration-line: underline;
  text-underline-position: under;
  text-transform: capitalize;
  cursor: pointer;
  @media (max-width: 1024px) {
    display: none;
  }
  user-select: none;
  &.disabled {
    cursor: default;
    color: #a3a3a3;
    &:hover {
      text-decoration: underline;
    }
  }
`

const CustomDuration = ({
  applyDuration,
  addCustomDuration,
  customDuration,
  filterUrl,
  durationOptions,
  isFromClassFinderPage
}) => {
  const [min, setMin] = useState('')
  const [max, setMax] = useState('')

  const onInput = (e) => {
    const { name, value } = e.target
    const trimmedValue = value.replace(/\D/g, '').slice(0, 3)
    e.target.value = trimmedValue
    if (name === 'min') {
      setMin(trimmedValue)
      addCustomDuration({ min: trimmedValue, max })
    } else if (name === 'max') {
      setMax(trimmedValue)
      addCustomDuration({ min, max: trimmedValue })
    }
  }

  const enabled =
    (Boolean(min) && Number(min) !== 0) || (Boolean(max) && Number(max) !== 0)

  const onApply = () => {
    enabled && applyDuration({ durationOptions, isFromClassFinderPage })
  }

  const pushWindowState = () => {
    window.history.pushState(
      filterUrl,
      null,
      `${window.location.pathname}?${filterUrl}`
    )
  }

  useEffect(() => {
    if (customDuration.max) {
      setMax(customDuration.max)
      pushWindowState()
    }
    if (customDuration.min != null) {
      setMin(customDuration.min)
      pushWindowState()
    }
  }, [filterUrl])
  return (
    <OuterContainer>
      <InputBox
        label='min'
        name='min'
        placeholder='Min'
        type='text'
        value={min}
        onInput={onInput}
      />
      <ResponsiveSVG SVG={hiphen} width='20px' height='20px' />
      <InputBox
        label='max'
        name='max'
        placeholder='Max'
        type='text'
        value={max}
        onInput={onInput}
      />
      <Apply className={`${enabled ? '' : 'disabled'}`} onClick={onApply}>
        Apply
      </Apply>
    </OuterContainer>
  )
}

const mapStateToProps = (state) => {
  return {
    duration: state.ui.planEntries.filtered.duration,
    customDuration: state.ui.planEntries.customDuration,
    filterUrl: state.ui.planEntries.filterUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    applyDuration: ({ durationOptions, isFromClassFinderPage }) => {
      dispatch(applyDurationFilter({ durationOptions, isFromClassFinderPage }))
    },
    addCustomDuration: ({ min, max }) => {
      dispatch(addCustomDurationFilter({ min, max }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomDuration)
